import TimespanFrame from "./TimespanFrame.component.jsx";

export default TimespanFrame;
